import {BasicCPCLArg} from "./basic";
import {CommandClause, Commander, Raw, CPCLCommand} from "@psdk/frame-father";
import {InputImage, Pbita} from "@psdk/frame-imageb";

/**
 * Image
 */
export class CImage extends BasicCPCLArg<CImage> {

  private x: number;
  private y: number;
  private readonly compress: boolean;
  private readonly image: InputImage;
  private readonly reverse: boolean;
  private readonly threshold: number;

  constructor(options: {
    /**
     * Specify the x-coordinate, default is 0
     */
    x?: number,
    /**
     * Specify the y-coordinate, default is 0
     */
    y?: number,
    /**
     * enable compress image data, default is false
     */
    compress?: boolean,
    /**
     * enable reverse image data, default is false
     */
    reverse?: boolean,
    /**
     * threshold, default is 190
     */
    threshold?: number,
    /**
     * image canvas
     */
    image: InputImage,
  }) {
    super();
    this.x = options.x ?? 0;
    this.y = options.y ?? 0;
    this.compress = options.compress ?? false;
    this.reverse = options.reverse ?? false;
    this.threshold = options.threshold ?? 190;
    this.image = options.image;
  }

  clause(): CommandClause {
    const processer = new Pbita({
        command:'cpcl',
        threshold: this.threshold,
        compress: this.compress,
        reverse: this.reverse,
      }
    );
    const info = processer.process(this.image);
    const fimage = info.result.data;
    const fbytes = info.result.bytes;
    if (fimage == null) {
      throw new Error('Wrong image data');
    }
    let width = fimage.width;
    let height = fimage.height;
    const eWidth = Math.floor((width % 8 === 0) ? (width / 8) : (width / 8 + 1));


    const command = Commander.make().pushClause(CPCLCommand.with(this.header())
      .appendNumber(eWidth)
      .appendNumber(height)
      .appendNumber(this.compress ? this.x / 8 : this.x)
      .appendNumber(this.y)
      .appendNumber(this.compress ? fbytes.length : null)
      .clause(), false)
      .pushText(" ", {newline: false})
      .pushBinary(fbytes, false)
      .newline()
      .command();

    return Raw.binary(command.binary()).clause();
  }

  header(): string {
    return this.compress ? "ZG" : "CG";
  }

}

